export default __webpack_public_path__ + "static/media/12-32-25 3.553a108c.jpg";